// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import {
  goAnchor,
  GetQueryString
} from "./js/common.js";
import {
  setToken
} from "@/utils/auth";
import {
  parseTime
} from "@/utils/common";
import directives from "@/utils/directives";
import {
  share,
  getConfByKey
} from "@/api/common";
import BaiduMap from "vue-baidu-map";
import VueAnimateNumber from "vue-animate-number";
import RightBar from "@/components/rightBar.vue";
import pager from "@/components/pager/index.vue";
import './css/quillEditor.css';
import "./css/common.css";
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueAnimateNumber);
Vue.component("RightBar", RightBar);
Vue.component("pager", pager);
var a = "";
var List = null; //pc端菜单
var List1 = null; //手机端菜单
var basicInfo = null;
var mapKey = null;
var urlPrefix = null;
var baseInfo = null;
Vue.prototype.parseTime = parseTime;
router.beforeEach((to, from, next) => {
  if(to.name === null){
    next('404')
  }
  if (urlPrefix === null) {
    var info = {}
      async function getInfo() {
        // 获取百度key
        await getConfByKey({
          key: "sys.baidu.key"
        }).then(res => {
          // "Iu4XYnzBhRnS32QsTprSFoU9D5dbmW7t"
          Vue.use(BaiduMap, {
            ak: res.data.configValue
          });


        });
        // 获取手机号
        await getConfByKey({
          key: 'sys.sum.phone'
        }).then(res => {
          info.phone = res.data.configValue
        })
        // 获取地址
        await getConfByKey({
          key: 'sys.sum.address'
        }).then(res => {
          info.address = res.data.configValue
        })
        // 获取邮箱
        await getConfByKey({
          key: 'sys.sum.email'
        }).then(res => {
          info.email = res.data.configValue
        })
        // 获取关键字
        await getConfByKey({
          key: "sys.web.keyword"
        }).then(res => {
          document.querySelector('meta[name="Keywords"]').setAttribute('content', res.data.configValue);
          document.querySelector('meta[name="description"]').setAttribute('content', res.data.remark);
        })
        // 获取阿里云前缀
        await getConfByKey({
          key: "aliyun.urlPrefix"
        }).then(res => {
          urlPrefix = res.data.configValue;
          // this.this.$router.push({ name: "home" });
        });
        // 获取logo
        await getConfByKey({key:'sys.sum.logo'}).then(res=>{
          info.logo = res.data.configValue
        })
        // 获取备案号
        await getConfByKey({key:'sys.keepon.numer'}).then(res=>{
          info.keeponnumber = res.data.configValue
        })
        // 获取公众号
        await getConfByKey({key:'sys.wechat.qrcode'}).then(res=>{
          info.qrcode = res.data.configValue
        })
        // 获取客服
        await getConfByKey({key:'sys.wechat.customer.qrcode'}).then(res=>{
          info.customerQrcode = res.data.configValue
        })
        // 获取底部背景图
        await getConfByKey({key:'sys.footer.bgimage'}).then(res=>{
          info.footerBg = res.data.configValue
        })
        baseInfo = info
        next();
      }
      getInfo()
  } else {
    next();
  }
});

Vue.prototype.getBaseInfo = function () {
  return baseInfo
};

Vue.prototype.getwg = function (name) {
  if (name) {
    a = name;
  } else {
    return a;
  }
};
Vue.prototype.saveMenuList = function (val) {
  if (val) {
    List = val;
  } else {
    return List;
  }
};
Vue.prototype.setUrlPrefix = function (val) {
  urlPrefix = val;
};
Vue.prototype.getUrlPrefix = function (url) {
  return urlPrefix + url;
};
Vue.prototype.saveBasicInfo = function (val) {
  if (val) {
    basicInfo = val;
    setToken("basicInfo", val);
  } else {
    return basicInfo;
  }
};
/**
 * 加载图片，直到加载完成后才调用回调函数
 * @param url 后面读取图片流的url
 * @param callback 回调函数
 */
Vue.prototype.loadImage = function (url, callback) {
  var img = new Image();
  img.src = url;
  var timer = setInterval(function () {
    if (img.complete) {
      callback(img);
      clearInterval(timer);
    }
  }, 50);
};

/**
 * 判断是否为手机
 */

Vue.prototype.isMobile = function () {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  if (flag == null) {
    return false;
  } else {
    return true;
  }
};

Vue.prototype.postMessage = function (
  shareTitle,
  shareDesc,
  shareLink,
  shareImg
) {
  if (!shareTitle) {
    return;
  }
  var host = window.location.host;
  var str = "";
  var userAppId = "";
  var userTimestamp = "";
  var userNonceStr = "";
  var userSignature = "";
  share({
    url: encodeURIComponent(window.location.href),
    type: "web"
  }).then(res => {
    str = res;
    userAppId = str.appId;
    userTimestamp = str.timestamp;
    userNonceStr = str.nonceStr;
    userSignature = str.signature;
    wx.config({
      // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: userAppId, // 必填，公众号的唯一标识
      timestamp: userTimestamp, // 必填，生成签名的时间戳
      nonceStr: userNonceStr, // 必填，生成签名的随机串
      signature: userSignature, // 必填，签名，见附录1
      jsApiList: [
        "onMenuShareAppMessage",
        "onMenuShareTimeline",
        "onMenuShareQQ",
        "onMenuShareWeibo",
        "onMenuShareQZone"
      ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    });
  });

  wx.ready(function () {
    //ready函数用于调用API，如果你的网页在加载后就需要自定义分享和回调功能，需要在此调用分享函数。//如果是微信游戏结束后，需要点击按钮触发得到分值后分享，这里就不需要调用API了，可以在按钮上绑定事件直接调用。因此，微信游戏由于大多需要用户先触发获取分值，此处请不要填写如下所示的分享API
    //分享到朋友圈
    var loc_link = window.location.href;
    if (loc_link.indexOf("?") >= 0) {
      loc_link = loc_link.split("?")[0];
    }
    wx.onMenuShareTimeline({
      title: shareTitle, // 分享标题
      desc: shareDesc, // 分享描述
      link: shareLink, // 分享链接
      imgUrl: shareImg, // 分享图标
      success: function () {
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    });

    //分享给朋友
    wx.onMenuShareAppMessage({
      title: shareTitle, // 分享标题
      desc: shareDesc, // 分享描述
      link: shareLink, // 分享链接
      imgUrl: shareImg, // 分享图标
      type: "", // 分享类型,music、video或link，不填默认为linkmusic
      dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空https://citi618.yeahc.com/mp3/123.mp3
      success: function () {
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    });
  });
  console.log(wx)

};
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key]);
});
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: {
    App
  },
  template: "<App/>",
  mounted: function () {
    //解决跳转到新页面不默认固定在顶部的bug
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    });
  },
  methods: {
    goAnchor,
    GetQueryString
  },
  watch: {
    "$route.query": function (newVal, oldVal) {
      var maodian = newVal.maodian;
      if (maodian) {
        this.goAnchor("#" + maodian);
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js